module.exports = __webpack_public_path__ + "static/media/infoJumbo2.be4c9160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/steidle/images/infoJumbo2.jpg
// module id = 561
// module chunks = 0